<div class="el-service-wrapper ">
    <div class="container">
        <div class="row gy-4 align-items-center">
            <div class="col-lg-6">
                <div class="el-service-left">
                    <div class="el-service-heading">
                        <h4 class="el-top-heading">My Progress reports</h4>
                        <h2 class="el-main-heading">Unlock Your Progress – Clear, Measurable, Motivating!</h2>
                        <p class="el-para">With every mock test on PowerPrep, you receive a detailed Progress Report
                            that goes beyond scores. These reports
                            highlight your strengths, pinpoint areas needing attention, and show improvement over time.
                        </p>
                        <p>📊 Topic-wise analysis – see exactly where you excel and where support is needed<br>
                            ⏱️ Time tracking – understand speed and accuracy for better time management<br>
                            🎯 Personalised feedback – tailored insights to guide the next step in preparation<br>
                            📈 Growth charts – measure consistent progress towards Olympiad success
                        </p><br>
                        <p>Your olympiad preparation journey becomes transparent, motivating, and <br>result-driven –
                            helping you see real improvement
                            with every attempt.
                        </p>
                    </div>
                    <div class="el-service-left-content">
                        <!-- <ul>
                            <li><span><input type="radio" id="test1" name="radio-group" checked>
                                    <label for="test1">Expert Instructions</label></span>


                            </li>
                            <li><span><input type="radio" id="test2" name="radio-group">
                                    <label for="test2">Student Scholarship</label></span>


                            </li>

                        </ul>

                        <a href="javascript:;" class="el-btn">Download Now</a> -->
                        <a [routerLink]="['/report']" class="el-btn mx-2 btn-info mt-3">View Reports</a>

                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="el-service-right">
                    <img src="../assets/images/all-instructor/service-img.png" alt="service image">


                </div>
            </div>
        </div>
    </div>
</div>